import {
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';

import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import { formatCurrencyInBDT } from '@/utils/currency-formater';

import { useBalanceSheet } from './balance-sheet.hook';

export const BalanceSheet = () => {
    const { data, isLoading, isError } = useBalanceSheet();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return <div>Error loading balance sheet</div>;
    }

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between py-4">
                    <PageHeading title="Balance Sheet" subTitle="" />
                </div>
            </HeadingWrapper>
            <Card>
                <CardContent className="p-4">
                    <Table>
                        <TableHeader className="w-full bg-gray-200">
                            <TableRow className="">
                                <TableHead className="w-1/2">Account</TableHead>
                                <TableHead className="text-right">
                                    Amount
                                </TableHead>
                            </TableRow>
                        </TableHeader>

                        <TableBody>
                            <TableRow>
                                <TableCell className="">Income</TableCell>
                                <TableCell className="text-right font-mono">
                                    {formatCurrencyInBDT(data?.income || 0)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="">Expense</TableCell>
                                <TableCell className="text-right font-mono">
                                    {formatCurrencyInBDT(data?.expense || 0)}
                                </TableCell>
                            </TableRow>{' '}
                            <TableRow>
                                <TableCell className="">
                                    Accounts Receivable
                                </TableCell>
                                <TableCell className="text-right font-mono">
                                    {formatCurrencyInBDT(
                                        data?.accounts_receivable || 0,
                                    )}
                                </TableCell>
                            </TableRow>{' '}
                            <TableRow>
                                <TableCell className="">
                                    Accounts Payable
                                </TableCell>
                                <TableCell className="text-right font-mono">
                                    {formatCurrencyInBDT(
                                        data?.accounts_payable || 0,
                                    )}
                                </TableCell>
                            </TableRow>{' '}
                            <TableRow>
                                <TableCell className="font-medium">
                                    Total
                                </TableCell>
                                <TableCell className="text-right font-mono">
                                    {formatCurrencyInBDT(data?.total || 0)}
                                </TableCell>
                            </TableRow>
                            {/* <TableRow>
                <TableCell
                  className="font-medium py-1.5 text-lg bg-gray-100"
                  colSpan={2}
                >
                  Assets
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="">Cash</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="">Bank</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="">Mobile Banking</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="">Accounts Receivable</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="">Total</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(2500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-medium py-1.5 text-lg bg-gray-100"
                  colSpan={2}
                >
                  Liabilities
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="">Accounts Payable</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="">Tax</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(0)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-medium py-1.5 text-lg bg-gray-100"
                  colSpan={2}
                >
                  Equity
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="">Total Sales</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="">Total Expenses</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(0)}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className="font-medium py-1.5 text-lg bg-gray-100"
                  colSpan={2}
                >
                  Total
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="">Total</TableCell>
                <TableCell className="text-right font-mono">
                  {formatCurrencyInBTD(500)}
                </TableCell>
              </TableRow> */}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </>
    );
};
